import { useCallback } from 'react';
import { useResource } from 'hooks/useResource';
import salesforceAccountsService from 'services/salesforceAccountsService';

const useAccountInteractionActivity = (accountId) => {
	const fetchFn = useCallback(async () => {
		if (!accountId) return null;
		return await salesforceAccountsService.getInteractionActivity(accountId);
	}, [accountId]);

	const { data, loading, error } = useResource({ fetchFn });

	return {
		totalTouchpoints: data?.total_touchpoints ?? null,
		typeCounts: data?.type_counts ?? [],
		loading,
		error,
	};
};

export default useAccountInteractionActivity;
